import React from "react";
import { Phone } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY } from "../../lib/media";
import { useLang } from "../../i18n/LanguageContext";

const MobileStickyCta = () => {
  const { t } = useLang();
  return (
    <a
      href={`tel:${PHONE_TEL}`}
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 flex items-center justify-center gap-2 bg-[#0055FF] hover:bg-[#3377FF] text-white h-[60px] font-semibold tracking-wide"
      data-testid="mobile-sticky-call"
    >
      <Phone className="w-5 h-5" />
      <span>{t.common.callNow}</span>
      <span className="opacity-80">· {PHONE_DISPLAY}</span>
    </a>
  );
};

export default MobileStickyCta;
